import {ErrorState} from 'presentation/components';
import {Loading} from 'presentation/components/Loading/Loading';
import {GuideEmptyState} from 'presentation/modules/guide/shared/ui/components/GuideEmptyState';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {NetworkGroups} from '../../../../../NetworkGroups';
import {HealthProvidersResultsV1Props} from '../../types';
import {Container} from './styles';

const {failToLoadTitle, failToLoadDescription, loading} = translations['pt-br'].commons;

export function ProvidersResultsV1({
	providersError,
	isFetching,
	shouldRenderEmptyState,
	networkList,
	refetchProvidersQuery,
}: HealthProvidersResultsV1Props) {
	if (isFetching) {
		return <Loading text={loading} minHeight="100%" />;
	}

	if (providersError) {
		return (
			<ErrorState
				title={failToLoadTitle}
				description={failToLoadDescription}
				handleRefresh={refetchProvidersQuery}
			/>
		);
	}

	if (shouldRenderEmptyState) {
		return <GuideEmptyState />;
	}

	return (
		<Container>
			<NetworkGroups list={networkList} />
		</Container>
	);
}
